import Image from 'next/image'

import Card from '~/components/Card'
import { Column, Grid } from '~/components/Grid'
import { urlForImage } from '~/lib/sanity.image'
import { SecondaryPage } from '~/lib/sanity.queries'

import PortableTextScrollAnimation from '../TextAnimation'

export default function Summary({
  content,
}: {
  content: SecondaryPage['summary']
}) {
  return (
    <section>
      <Grid className="text-center mb-7 md:mb-20">
        <Column className="col-span-12 relative">
          <div className="bg-gradient-blur opacity-20"></div>
          <div className="flex flex-col items-center justify-center relative">
            {content?.title && (
              <div className="h3 md:h4 text-center md:h2 text-pretty pb-1">
                <PortableTextScrollAnimation value={content.title} />
              </div>
            )}
            {content?.body && (
              <div className="mt-6 md:mt-8 md:body-large text-grey text-pretty max-w-3xl mx-auto">
                <PortableTextScrollAnimation value={content.body} />
              </div>
            )}
          </div>
        </Column>
      </Grid>
      <Grid className="auto-rows-fr">
        {content?.items?.map((item, index) => (
          <Column
            key={index}
            className="col-span-12 sm:col-span-10 sm:col-start-2 lg:col-span-6 lg:col-start-4 xl:col-span-4"
          >
            <Card className="h-full">
              <div className="flex w-full items-center xl:items-start flex-col text-center xl:text-left md:my-0">
                <Image
                  alt={item.title}
                  src={urlForImage(item.icon).url()}
                  width={32}
                  height={32}
                  className="mb-8 xl:mb-40"
                />
                <h5 className="h5 mb-4 md:mb-8">{item.title}</h5>
                <p className="text-grey body-large md:body-small">
                  {item.body}
                </p>
              </div>
            </Card>
          </Column>
        ))}
      </Grid>
    </section>
  )
}
